import { render, staticRenderFns } from "./SignatureTemplateEcase.vue?vue&type=template&id=bb72b172&scoped=true"
import script from "./SignatureTemplateEcase.vue?vue&type=script&lang=js"
export * from "./SignatureTemplateEcase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb72b172",
  null
  
)

export default component.exports